export enum NotificationLengthEnum {
	Quick = 1000,
	Normal = 2000,
	Long = 5000,
	ExtraLong = 20000,
}
